// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ComingSoonModule.css – beautiful module-specific coming soon */

.coming-soon-module {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(160deg, #0f0c29 0%, #302b63 40%, #24243e 100%);
}

.coming-soon-module::before {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--module-gradient);
  opacity: 0.15;
  mix-blend-mode: overlay;
  pointer-events: none;
}

/* Background shapes */
.csmm-bg-shapes {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.csmm-shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.4;
  animation: csmm-float 20s ease-in-out infinite;
}

.csmm-shape-1 {
  width:  min(60vw, 500px);
  height: min(60vw, 500px);
  top: -20%;
  right: -10%;
  background: var(--module-accent);
  animation-delay: 0s;
}

.csmm-shape-2 {
  width:  min(50vw, 400px);
  height: min(50vw, 400px);
  bottom: -15%;
  left: -10%;
  background: #a855f7;
  animation-delay: -7s;
}

.csmm-shape-3 {
  width:  min(40vw, 320px);
  height: min(40vw, 320px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #06b6d4;
  opacity: 0.2;
  animation-delay: -14s;
}

@keyframes csmm-float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33%      { transform: translate(30px, -30px) scale(1.05); }
  66%      { transform: translate(-20px, 20px) scale(0.95); }
}

/* Back button */
.csmm-back {
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, transform 0.2s;
  z-index: 10;
}

.csmm-back:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  transform: translateX(-2px);
}

.csmm-back-icon {
  font-size: 1.1rem;
}

/* Card */
.csmm-card {
  position: relative;
  width: min(92vw, 420px);
  padding: 2.5rem 2rem;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  box-shadow:
    0 25px 50px -12px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  opacity: 0;
  transform: translateY(24px) scale(0.96);
  transition: opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1),
              transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);
  z-index: 2;
}

.csmm-card-visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.csmm-glow {
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 200px;
  background: var(--module-gradient);
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.35;
  pointer-events: none;
}

.csmm-content {
  position: relative;
  text-align: center;
}

/* Icon */
.csmm-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  margin: 0 auto 1.25rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.csmm-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Title & tagline */
.csmm-title {
  margin: 0 0 0.5rem;
  font-size: clamp(1.6rem, 4.5vw, 2rem);
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.csmm-tagline {
  margin: 0 0 1.5rem;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.5;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
}

/* Coming Soon badge */
.csmm-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.06) 100%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 999px;
  margin-bottom: 1.25rem;
}

.csmm-badge-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.05em;
}

.csmm-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--module-accent);
  animation: csmm-bounce 1.2s ease-in-out infinite;
}

.csmm-dot:nth-child(2) { animation-delay: 0.15s; }
.csmm-dot:nth-child(3) { animation-delay: 0.3s; }
.csmm-dot:nth-child(4) { animation-delay: 0.45s; }

@keyframes csmm-bounce {
  0%, 60%, 100% { transform: translateY(0); }
  30%           { transform: translateY(-6px); }
}

/* Footer */
.csmm-footer {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.4);
}

/* Floating dots */
.csmm-floating-dots {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.csmm-fdot {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  animation: csmm-fdot 15s ease-in-out infinite;
  animation-delay: calc(var(--i) * -2.5s);
}

.csmm-fdot:nth-child(1) { top: 15%; left: 10%; }
.csmm-fdot:nth-child(2) { top: 25%; right: 15%; }
.csmm-fdot:nth-child(3) { top: 60%; left: 8%; }
.csmm-fdot:nth-child(4) { top: 70%; right: 12%; }
.csmm-fdot:nth-child(5) { top: 40%; right: 5%; }
.csmm-fdot:nth-child(6) { top: 85%; left: 20%; }

@keyframes csmm-fdot {
  0%, 100% { transform: translate(0, 0); opacity: 0.2; }
  50%      { transform: translate(10px, -15px); opacity: 0.5; }
}

@media (max-width: 480px) {
  .csmm-card {
    padding: 2rem 1.5rem;
  }

  .csmm-back {
    top: 1rem;
    left: 1rem;
    font-size: 0.85rem;
    padding: 0.5rem 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/utilities/tables/comingSoon/ComingSoonModule.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,WAAW,6CAA6C,EAAE;EAC1D,WAAW,6CAA6C,EAAE;AAC5D;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,8DAA8D;EAC9D,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB;;2CAEyC;EACzC,UAAU;EACV,uCAAuC;EACvC;2DACyD;EACzD,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iGAAiG;EACjG,2CAA2C;EAC3C,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA,yBAAyB,sBAAsB,EAAE;AACjD,yBAAyB,qBAAqB,EAAE;AAChD,yBAAyB,sBAAsB,EAAE;;AAEjD;EACE,gBAAgB,wBAAwB,EAAE;EAC1C,gBAAgB,2BAA2B,EAAE;AAC/C;;AAEA,WAAW;AACX;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA,0BAA0B,QAAQ,EAAE,SAAS,EAAE;AAC/C,0BAA0B,QAAQ,EAAE,UAAU,EAAE;AAChD,0BAA0B,QAAQ,EAAE,QAAQ,EAAE;AAC9C,0BAA0B,QAAQ,EAAE,UAAU,EAAE;AAChD,0BAA0B,QAAQ,EAAE,SAAS,EAAE;AAC/C,0BAA0B,QAAQ,EAAE,SAAS,EAAE;;AAE/C;EACE,WAAW,0BAA0B,EAAE,YAAY,EAAE;EACrD,WAAW,iCAAiC,EAAE,YAAY,EAAE;AAC9D;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,uBAAuB;EACzB;AACF","sourcesContent":["/* ComingSoonModule.css – beautiful module-specific coming soon */\n\n.coming-soon-module {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(160deg, #0f0c29 0%, #302b63 40%, #24243e 100%);\n}\n\n.coming-soon-module::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: var(--module-gradient);\n  opacity: 0.15;\n  mix-blend-mode: overlay;\n  pointer-events: none;\n}\n\n/* Background shapes */\n.csmm-bg-shapes {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.csmm-shape {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.4;\n  animation: csmm-float 20s ease-in-out infinite;\n}\n\n.csmm-shape-1 {\n  width:  min(60vw, 500px);\n  height: min(60vw, 500px);\n  top: -20%;\n  right: -10%;\n  background: var(--module-accent);\n  animation-delay: 0s;\n}\n\n.csmm-shape-2 {\n  width:  min(50vw, 400px);\n  height: min(50vw, 400px);\n  bottom: -15%;\n  left: -10%;\n  background: #a855f7;\n  animation-delay: -7s;\n}\n\n.csmm-shape-3 {\n  width:  min(40vw, 320px);\n  height: min(40vw, 320px);\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #06b6d4;\n  opacity: 0.2;\n  animation-delay: -14s;\n}\n\n@keyframes csmm-float {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  33%      { transform: translate(30px, -30px) scale(1.05); }\n  66%      { transform: translate(-20px, 20px) scale(0.95); }\n}\n\n/* Back button */\n.csmm-back {\n  position: absolute;\n  top: 1.5rem;\n  left: 1.5rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1rem;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s, transform 0.2s;\n  z-index: 10;\n}\n\n.csmm-back:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.25);\n  transform: translateX(-2px);\n}\n\n.csmm-back-icon {\n  font-size: 1.1rem;\n}\n\n/* Card */\n.csmm-card {\n  position: relative;\n  width: min(92vw, 420px);\n  padding: 2.5rem 2rem;\n  background: rgba(255, 255, 255, 0.06);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 24px;\n  box-shadow:\n    0 25px 50px -12px rgba(0, 0, 0, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  opacity: 0;\n  transform: translateY(24px) scale(0.96);\n  transition: opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1),\n              transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);\n  z-index: 2;\n}\n\n.csmm-card-visible {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n}\n\n.csmm-glow {\n  position: absolute;\n  top: -80px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 200px;\n  height: 200px;\n  background: var(--module-gradient);\n  border-radius: 50%;\n  filter: blur(60px);\n  opacity: 0.35;\n  pointer-events: none;\n}\n\n.csmm-content {\n  position: relative;\n  text-align: center;\n}\n\n/* Icon */\n.csmm-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 100px;\n  margin: 0 auto 1.25rem;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.csmm-icon {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n/* Title & tagline */\n.csmm-title {\n  margin: 0 0 0.5rem;\n  font-size: clamp(1.6rem, 4.5vw, 2rem);\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.csmm-tagline {\n  margin: 0 0 1.5rem;\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.5;\n  max-width: 320px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Coming Soon badge */\n.csmm-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.5rem 1rem;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.06) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 999px;\n  margin-bottom: 1.25rem;\n}\n\n.csmm-badge-text {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #fff;\n  letter-spacing: 0.05em;\n}\n\n.csmm-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--module-accent);\n  animation: csmm-bounce 1.2s ease-in-out infinite;\n}\n\n.csmm-dot:nth-child(2) { animation-delay: 0.15s; }\n.csmm-dot:nth-child(3) { animation-delay: 0.3s; }\n.csmm-dot:nth-child(4) { animation-delay: 0.45s; }\n\n@keyframes csmm-bounce {\n  0%, 60%, 100% { transform: translateY(0); }\n  30%           { transform: translateY(-6px); }\n}\n\n/* Footer */\n.csmm-footer {\n  margin: 0;\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n/* Floating dots */\n.csmm-floating-dots {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.csmm-fdot {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n  animation: csmm-fdot 15s ease-in-out infinite;\n  animation-delay: calc(var(--i) * -2.5s);\n}\n\n.csmm-fdot:nth-child(1) { top: 15%; left: 10%; }\n.csmm-fdot:nth-child(2) { top: 25%; right: 15%; }\n.csmm-fdot:nth-child(3) { top: 60%; left: 8%; }\n.csmm-fdot:nth-child(4) { top: 70%; right: 12%; }\n.csmm-fdot:nth-child(5) { top: 40%; right: 5%; }\n.csmm-fdot:nth-child(6) { top: 85%; left: 20%; }\n\n@keyframes csmm-fdot {\n  0%, 100% { transform: translate(0, 0); opacity: 0.2; }\n  50%      { transform: translate(10px, -15px); opacity: 0.5; }\n}\n\n@media (max-width: 480px) {\n  .csmm-card {\n    padding: 2rem 1.5rem;\n  }\n\n  .csmm-back {\n    top: 1rem;\n    left: 1rem;\n    font-size: 0.85rem;\n    padding: 0.5rem 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
